// importing dependencies

import React from "react";
import "./App.scss";

// importing AppRoute component

import AppRoutes from "./routes/AppRoutes";


// main App function

function App() {
  return (
    <div className="App">
      <AppRoutes />
    </div>
  );
}

export default App;
